import Cookie from "js-cookie";

import { DEVICE_FINGERPRINT_COOKIE } from "src/shared/constants/fingerprint";

const deviceFingerprint = () => Cookie.get(DEVICE_FINGERPRINT_COOKIE) || null;

export default deviceFingerprint;
